module.exports = __webpack_public_path__ + "static/media/58809B.d32bebac.jpg";